<template>
  <div class="w-full flex flex-wrap max-w-4xl mx-auto py-4">
    <div class="w-1/2">
      <b-button @click="showGenerate" v-if="!loading && settings.length">Generate Monthly Items</b-button>
    </div>
    <div class="w-1/2 mb-4 text-right">
      <b-button type="secondary" class="mr-2" @click="showReorder" v-if="!loading && settings.length"
        >Reorder Items</b-button
      >
      <b-button @click="showCreate ">New Item</b-button>
    </div>

    <div class="w-full text-center" v-if="!loading && !settings.length">
      You do not have any budgets setup. Please <a href="#" class="text-green-800 underline" @click="showCreate">create one</a> to get started.
    </div>

    <budget-setting-item
      v-for="item in settings"
      :key="item.id"
      :data="item"
      :all-companies="companies"
    ></budget-setting-item>
  </div>
</template>

<script>
import lodash from "lodash"
import { EventBus } from "../events"
import CreateForm from "@/components/CreateForm"
import ReorderForm from "@/components/ReorderForm"
import GeneratePeriodsForm from "@/components/GeneratePeriodsForm"
import BudgetSettingItem from "@/components/BudgetSettingItem"

export default {
  name: "home",
  components: { BudgetSettingItem },
  data() {
    return {
      loading: false,
      companies: [],
      settings: [],
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      EventBus.$emit("loading:start")
      await this.axios
        .get("budget/list")
        .then(({ data }) => {
          let companies = lodash.orderBy(data.data, "name")
          this.companies = companies
        })
        .finally(() => {})

      await this.axios
        .get("budget")
        .then(({ data }) => {
          this.items = data.periods
          this.settings = data.settings
        })
        .finally(() => {})

      EventBus.$emit("loading:end")
      this.loading = false
    },
    itemAdded() {
      this.$modal.hide("create-modal")
      this.fetch()
    },
    showCreate() {
      this.$modal.show(
        CreateForm,
        {
          companies: this.companies,
        },
        {
          width: 800,
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      )
    },
    showReorder() {
      this.$modal.show(
        ReorderForm,
        {
          existing: this.settings,
        },
        {
          width: 800,
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      )
    },
    showGenerate() {
      this.$modal.show(
        GeneratePeriodsForm,
        {},
        {
          width: 800,
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      )
    },
  },
  mounted() {
    this.fetch()
    EventBus.$on("fetch-settings", () => this.fetch())
  },
}
</script>

<style lang="scss">
</style>
